import axios from 'axios';
import { taskApi as api } from './api';
import {
  AssigneeAttributes,
  AssignmentStats,
} from 'types/store/availableAssignees';
import { JsonApiResource, JsonApiResponse } from 'types/store/jsonApi';

export interface AvailableAssigneeData
  extends JsonApiResource<AssigneeAttributes> {
  meta?: AssignmentStats;
}

export interface AvailableAssigneesResponse {
  assignees: AvailableAssigneeData[];
  meta: {
    total: number;
    taskCount: number;
  };
  links: Record<string, string>;
}

interface FetchAvailableAssigneesParams {
  url: string;
}

export const fetchAvailableAssignees = async (
  params: FetchAvailableAssigneesParams
): Promise<JsonApiResponse<AvailableAssigneesResponse>> => {
  const response = await api.get<JsonApiResponse<AvailableAssigneesResponse>>(
    params.url
  );

  if (axios.isAxiosError(response)) {
    throw response;
  }

  return response.data;
};
